module.exports = __webpack_public_path__ + "media/images/team_julaimas-c8a9b7fd1392d854cbd7bfb9cb123daf.jpg";